'use es6';

import { createSelector } from 'reselect';
export const getAdAccountFromProps = (__state, props) => props.adAccount;
export const getAccountIdFromProps = (__, props) => props.accountId;
export const getLocationFromProps = (__, props) => props.location;
export const getNetworkFromProps = (__, props) => props.network;
export const getParams = (__state, props) => {
  return props.match.params;
};
export const getCampaignIdFromParams = createSelector(getParams, params => params.campaignId);
export const getAdGroupIdFromParams = createSelector(getParams, params => params.adGroupId);
export const getNetworkFromParams = createSelector(getParams, params => params.network && params.network.toUpperCase());
export const getAudienceIdFromParams = createSelector(getParams, params => params.audienceId);
export const getTypeFromParams = createSelector(getParams, params => params.type);
export const getSequenceIdFromParams = createSelector(getParams, params => params.sequenceId);
export const getEntityFromProps = (__, props) => props.entity;
export const getAdCreationTypeFromProps = (__, props) => props.adCreationType;